<template>
<div class="test">
    <b-container>
        <b-row>
            <b-col cols="12">
                <img class="heading" src="../../assets/heading.jpeg" alt="">
                <br><br>
            </b-col>
        </b-row>
        <br><br>
        <b-row v-if="!isMobile()" id="About">
            <b-col cols="6">
                <img class="display" src="../../assets/gifdisplay.gif" alt="">
            </b-col>
            <b-col cols="6" class="para">
                <p>Hello, I am B11, flying through space on my way to a new adventure I suddenly heard a loud noise coming from my spaceship! The directional motor capacitor has begun to overheat, engine's thrust and velocity decreasing. I knew that I had to make an emergency stop! Earth, the closest habitable planet on which I could land and make repairs... Finding spare parts will be tricky but luckily Earth's economy offers a trade system where currency can be traded for items and vice versa. If I want a chance at getting back into space to continue with my adventures or to get home then I would have to think of ways to generate the Earthly currencies. Let's start with a photoshoot, it's time for an NFT.</p>
            </b-col>
        </b-row>

        <b-row v-if="isMobile()">
            <b-col cols="12">
                <img class="display" src="../../assets/gifdisplay.gif" alt="">
                <br><br>
                <p class="para">Hello, I am B11, flying through space on my way to a new adventure I suddenly heard a loud noise coming from my spaceship! The directional motor capacitor has begun to overheat, engine's thrust and velocity decreasing. I knew that I had to make an emergency stop! Earth, the closest habitable planet on which I could land and make repairs... Finding spare parts will be tricky but luckily Earth's economy offers a trade system where currency can be traded for items and vice versa. If I want a chance at getting back into space to continue with my adventures or to get home then I would have to think of ways to generate the Earthly currencies. Let's start with a photoshoot, it's time for an NFT.</p>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
export default {
    name: "HomeHeader",
    methods:{
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped>
.heading
{
    width: 100%;
}
.para
{
    margin-top: 6%;
    color: white;
    font-size: 2vh;
    text-transform: uppercase;
    font-weight: bold;
    text-align: justify;
    font-style: italic;
}
.display
{
    width: 75%;
}
.styleAbout
{
    color: white;
    text-transform: uppercase;
    font-size: 4vh;
    font-style: italic;
    font-weight: bolder;
    letter-spacing: 1vh;
}
</style>


// WEBPACK FOOTER //
// src/components/HomeComp/HomeHeader.vue